/* @flow */
import React, { useContext, memo } from 'react'
import S from './RSVP1.styled'
import RSVP1Card from './RSVP1.card'
import { EditingContext } from '@contexts'
import RSVPRegistrationPopup from '@website/common/components/RSVPRegistrationPopup'
import RSVPForm from '@website/common/components/RSVPForm'
import useEventRegistration from '@website/common/hooks/useEventRegistration'

const RSVP1 = memo(props => {
  const {
    data: {
      backgroundImgUrl,
      bgOverlayTransparency,
      backgroundImgDimensions,
      cardImage,
      centerImage,
      subtitleAlignment,
      titleAlignment,
      paragraphAlignment,
      dateAlignment,
      locationAlignment
    },
    eventData,
    uniqId
  } = props

  const eventCardMetaData = {
    cardImage,
    centerImage,
    subtitleAlignment,
    titleAlignment,
    paragraphAlignment,
    dateAlignment,
    locationAlignment
  }

  const { isEditing } = useContext(EditingContext)
  const {
    onClick: onRSVPBtnClick,
    isLoading,
    additionalGuestCount,
    isRegistrationClosedPopupOpen,
    closeRegistrationClosedPopup,
    setGuestLimit
  } = useEventRegistration(eventData.id, eventData.form.additionalGuestNumber)

  const registrationClosedPopupData = eventData.popups.closed

  return (
    <S.ComponentWrapper>
      <S.StyledContainer
        isEditing={isEditing}
        backgroundImgUrl={backgroundImgUrl}
        bgOverlayTransparency={bgOverlayTransparency}
        backgroundImgDimensions={backgroundImgDimensions}
      >
        <S.WmCustomContainer>
          <RSVP1Card
            detailsData={eventData.details}
            metaData={eventCardMetaData}
            onRSVPBtnClick={onRSVPBtnClick}
            isLoading={isLoading}
          />
        </S.WmCustomContainer>
      </S.StyledContainer>
      <RSVPForm
        compId={uniqId}
        eventId={eventData.id}
        formData={eventData.form}
        popupsData={eventData.popups}
        detailsData={eventData.details}
        additionalGuestCount={additionalGuestCount}
        setGuestLimit={setGuestLimit}
      />
      {!isEditing ? (
        <RSVPRegistrationPopup
          isPopupOpen={isRegistrationClosedPopupOpen}
          title={registrationClosedPopupData.title.text}
          paragraph={registrationClosedPopupData.paragraph.text}
          onClose={closeRegistrationClosedPopup}
        />
      ) : null}
    </S.ComponentWrapper>
  )
})

export default RSVP1
